
import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class ResetServiceTypeCommand extends IRequestCommand<boolean, ErrorDetails, IResetServiceTypeCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carrier/users/{userId}/transportTypes/{serviceTypeId}/reset';

  public setUrlParameters(carrierId: string) {
    this._commandUrl = this._commandUrl.replace('{userId}', carrierId.toString());
  }
}

export interface IResetServiceTypeCommandParameters extends ICommandParameters {
  serviceTypeId: number;
  userId: number;
}
